import { Link } from "react-router-dom";
import { Button, Progress, Label } from "semantic-ui-react";

export function CourseDetail(props) {
  const { course, onOpenCloseModal } = props;

  const getStatusColor = (row) => {
    // Si recoveryStatus = 2, significa que hay nota de recuperación
    if (row.recoveryStatus === 2) {
      if (row.recoveryGrade >= 11) return "blue"; // Recuperado - azul
      return "red"; // Desaprobado
    }
    // Si no tiene recuperación, evaluar por promedio normal
    if (row.averageGrade >= 11) return "green";
    if (row.averageGrade <= 10) return "red";
    return "brown";
  };

  const getStatusText = (row) => {
    if (row.recoveryStatus === 2) {
      if (row.recoveryGrade >= 11) return "RECUPERADO";
      return "DESAPROBADO";
    }
    if (row.averageGrade >= 11) return "APROBADO";
    if (row.averageGrade <= 10) return "DESAPROBADO";
    return "SIN DEFINIR";
  };

  const getRecoveryGradeDisplay = (row) => {
    if (row.recoveryStatus === 1) return "-";
    if (row.recoveryStatus === 2) return row.recoveryGrade || "-";
    return "-";
  };

  return (
    <div className="course-summary-modal">
      {/* Progreso del Curso */}
      <div className="course-summary-modal__progress-section">
        <div className="course-summary-modal__progress-header">
          <h3>Progreso del Curso</h3>
        </div>
        <Progress
          indicating
          className="course-card__progress"
          percent={parseInt(course.progress)}
        >
          <div></div>
          <div>{course.progress}%</div>
        </Progress>
      </div>

      {/* Calificaciones */}
      <div className="course-summary-modal__grades-section">
        <h3>Calificaciones</h3>
        <div className="course-summary-modal__grades-grid">
          <div className="course-summary-modal__grade-card">
            <div className="course-summary-modal__grade-label">
              Cuestionarios
            </div>
            <div className="course-summary-modal__grade-value">
              {course.questionnaireGrade}
            </div>
          </div>
          <div className="course-summary-modal__grade-card">
            <div className="course-summary-modal__grade-label">Tareas</div>
            <div className="course-summary-modal__grade-value">
              {course.homeworkGrade}
            </div>
          </div>
          <div className="course-summary-modal__grade-card">
            <div className="course-summary-modal__grade-label">Conducta</div>
            <div className="course-summary-modal__grade-value">
              {course.conductGrade}
            </div>
          </div>
          <div className="course-summary-modal__grade-card">
            <div className="course-summary-modal__grade-label">Promedio</div>
            <div className="course-summary-modal__grade-value">
              {course.averageGrade}
            </div>
          </div>
        </div>
      </div>

      {/* Recuperación */}
      <div className="course-summary-modal__recovery-section">
        <h3>Estado del Curso</h3>

        <div className="course-summary-modal__recovery-row">
          <span>Nota de Recuperación:</span>
          <span className="course-summary-modal__recovery-grade">
            {getRecoveryGradeDisplay(course)}
          </span>
        </div>

        <div className="course-summary-modal__recovery-row">
          <span>Estado Final:</span>
          <Label color={getStatusColor(course)} size="large">
            {getStatusText(course)}
          </Label>
        </div>
      </div>

      {/* Botones */}
      <div className="course-summary-modal__actions">
        <Button
          className="course-summary-modal__btn-close"
          onClick={onOpenCloseModal}
        >
          Cerrar
        </Button>
        <Button
          className="course-summary-modal__btn-details"
          as={Link}
          to={`/student/myCourses/${course.syllabuSubjectGradeId}`}
        >
          Ir la curso
        </Button>
      </div>
    </div>
  );
}
